import React from 'react';
import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope } from '@bechtel/types';

export function usePlanningPermissions() {
  const { hasPermissionScope } = useAppUser();
  const planningPermissions = React.useMemo(() => {
    const canPlanAssignedMilestones = hasPermissionScope({
      permission: AuthPermission.MANAGE_PLANNING,
      scope: AuthScope.MY_WORK_PACKAGES,
    });
    const canPlanAreaMilestones = hasPermissionScope({
      permission: AuthPermission.MANAGE_PLANNING,
      scope: AuthScope.MY_AREA,
    });
    const canViewAllCrewsProgress = hasPermissionScope({
      permission: AuthPermission.VIEW_ALL_CREWS_PROGRESS,
      scope: AuthScope.YES,
    });

    const canPlanMilestones = canPlanAssignedMilestones || canPlanAreaMilestones;
    //TODO: Enable for Lead SuperIntendents
    // const canPlanAllMilestones = hasPermissionScope({
    //   permission: AuthPermission.MANAGE_PLANNING,
    //   scope: AuthScope.ALL_WORK_PACKAGES,
    // });
    const canViewPlan = hasPermissionScope({
      permission: AuthPermission.VIEW_PLANNING,
      scope: AuthScope.APPLICATION,
    });
    return {
      canPlanMilestones,
      canPlanAssignedMilestones,
      canPlanAreaMilestones,
      canViewPlan,
      canViewAllCrewsProgress,
    };
  }, [hasPermissionScope]);
  return planningPermissions;
}
